export default {
  dota2: [],
  csgo: []
}